<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { cubicOut } from "svelte/easing";
  import { fade, fly } from "svelte/transition";
  import type { ToastType } from "./store";

  export let type: ToastType = "info";
  export let dismissible = true;
  export let width = "1em";

  const dispatch = createEventDispatcher<{ dismiss: void }>();
</script>

<article class={`toast ${type}`} role="alert" in:fly={{ y: 12, duration: 220, easing: cubicOut }} out:fade={{ duration: 140 }}>
  <span class="icon" aria-hidden="true">
    {#if type === "success"}
      <svg
        width={width}
        style="text-align: center; display: inline-block;"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"
        />
      </svg>
    {:else if type === "info"}
      <svg
        width={width}
        style="text-align: center; display: inline-block;"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        />
      </svg>
    {:else}
      <svg
        width={width}
        style="text-align: center; display: inline-block;"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.9 313.4-22.5 22.5a12 12 0 0 1-17 0L256 261.5l-82.4 82.4a12 12 0 0 1-17 0l-22.5-22.5a12 12 0 0 1 0-17l82.4-82.4-82.4-82.4a12 12 0 0 1 0-17l22.5-22.5a12 12 0 0 1 17 0l82.4 82.4 82.4-82.4a12 12 0 0 1 17 0l22.5 22.5a12 12 0 0 1 0 17L295.5 222l82.4 82.4a12 12 0 0 1 0 17z"
        />
      </svg>
    {/if}
  </span>

  <span class="text"><slot /></span>

  {#if dismissible}
    <button type="button" class="close" aria-label="Dismiss toast" on:click={() => dispatch("dismiss")}>
      ×
    </button>
  {/if}
</article>

<style>
  .toast {
    width: 20rem;
    border-radius: 0.2rem;
    padding: 0.8rem 1.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    color: white;
  }

  .toast.info {
    background-color: SkyBlue;
  }

  .toast.success {
    background-color: MediumSeaGreen;
  }

  .toast.error {
    background-color: IndianRed;
  }

  .icon {
    width: 1.2rem;
    min-width: 1.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    margin-left: 1rem;
    margin-right: auto;
    font-size: 0.95rem;
    overflow-wrap: anywhere;
  }

  .close {
    border: 0;
    background: transparent;
    color: white;
    cursor: pointer;
    opacity: 0.9;
    font-size: 1rem;
    line-height: 1;
    padding: 0;
  }

  .close:hover {
    opacity: 1;
  }
</style>
